import { FlexProps } from "@chakra-ui/layout";
import { Flex } from "@chakra-ui/react";
import React from "react";
import Card from "../Card";

type ServiceCardProps = FlexProps;
const ServiceCard: React.FC<ServiceCardProps> = ({ children, ...rest }) => {
  return (
    <Card
      w="50%"
      h="90%"
      bg="white"
      borderRadius="20px"
      direction="column"
      boxShadow="dark-lg"
      {...rest}
      ml={10}
      mr={10}
      mt={2}
    >
      <Flex
        justify="space-between"
        direction="column"
        align="center"
        h="90%"
        pt={10}
        color="black"
      >
        {children}
      </Flex>
    </Card>
  );
};

export default ServiceCard;
